import {getNestedValue} from "@Common/utils/arr-path";

import {applyResultCart} from "../common/apply-result-cart";

export const setCreditCards = (cards, {apis, clearBilling = false}) => ({
    action: async (cart) => {

        const resultCart = await apis.next.cart.updateCart({
            cartId: cart.cartId,
            ...cards?.length && {
                "payments": {
                    creditCards: cards,
                },
            },
            ...clearBilling ? {
                "removePayments": getNestedValue(cart, ["appliedPayments"]),
            } : {
                "removePayments": {
                    creditCards: getNestedValue(cart, ["appliedPayments", "creditCards"]),
                },
            },
            appliedPayments: null,
        });

        return {
            change: applyResultCart(resultCart),
        };
    },
});

